import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { RootStoreModule } from './store/store.module';
import { I18nModule } from './i18n/i18n.module';
import { CoreModule } from './core/core.module';
import { environment } from '../environments/environment';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';


export const appConfig: ApplicationConfig = {

 
  providers: [

    provideHttpClient(withFetch()),

    provideBrowserGlobalErrorListeners(),

    provideRouter(routes),

    provideClientHydration(withEventReplay()),

    provideAnimations(),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: './assets/i18n/',
        suffix: '.json',
      },
    },

    importProvidersFrom(
      BrowserModule,
      SharedModule,
      FlexLayoutModule,
      RootStoreModule,
      I18nModule,
      CoreModule.forRoot({ environment })
    )
  ]
};

